import { Skeleton } from "@volca/ui/components/ui/skeleton";
import { Text } from "@volca/ui/components/ui/text";
import type { DocumentCitation } from "@/profitability/documents/citation";
import { DocumentPreview } from "@/profitability/documents/document-preview";
import { useDocumentDetail } from "@/profitability/documents/query";

/**
 * A file as it was read, the Documents tab's Preview, opened on the cited
 * row and cell: for text, which no viewer draws, and a CSV too large to draw
 * as a spreadsheet.
 */
export const SourcePreview = ({
  businessId,
  documentId,
  citation,
}: {
  businessId: string;
  documentId: string;
  citation: DocumentCitation;
}) => {
  const detail = useDocumentDetail(businessId, documentId);
  if (detail.isPending)
    return <Skeleton className="min-h-0 flex-1 rounded-xl" />;
  if (detail.isError)
    return <Text tone="muted">This file could not be shown.</Text>;
  return (
    <DocumentPreview
      businessId={businessId}
      document={detail.data}
      citation={citation}
    />
  );
};
